module.exports = __webpack_public_path__ + "media/images/flags/BH-78ef8c26179b4a3e091d80f3d534b48a.svg";